export var ACTION;
(function (ACTION) {
    ACTION["VIEW_DETAILS_DIRECT"] = "VIEW_DETAILS_DIRECT";
    ACTION["FAQS_DIRECT"] = "FAQS_DIRECT";
    ACTION["GO_BACK"] = "GO_BACK";
    ACTION["NEED_HELP"] = "NEED_HELP";
    ACTION["CHECK_ELIGIBLE_LIMIT"] = "CHECK_ELIGIBLE_LIMIT";
    ACTION["CONTINUE_EDIT_LIMIT"] = "CONTINUE_EDIT_LIMIT";
    ACTION["CONTINUE_APPLICATION"] = "CONTINUE_APPLICATION";
    ACTION["CONTINUE_UNLOCK_LIMIT"] = "CONTINUE_UNLOCK_LIMIT";
})(ACTION || (ACTION = {}));
